import script from "./navbar_styled.vue?vue&type=script&setup=true&lang=js"
export * from "./navbar_styled.vue?vue&type=script&setup=true&lang=js"

import "./navbar_styled.vue?vue&type=style&index=0&id=01bb019f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01bb019f"]])

export default __exports__